import React, { Component } from 'react';
import {
  ApolloProvider, ApolloClient, HttpLink, InMemoryCache, disableFragmentWarnings
} from '@apollo/client';
import PropTypes from 'prop-types';
import { BatchHttpLink } from 'apollo-link-batch-http';
import typeDefs from './typesDefs.graphql';
import { getRelativeAPIPath, dataIdFromObject, typePolicies, clientBatchKeys } from './util';
import possibleTypes from '../shapes/possibleTypes.json';

let client;

disableFragmentWarnings();

const cache = new InMemoryCache({
  possibleTypes,
  dataIdFromObject,
  typePolicies
});

if (typeof window !== 'undefined' && window.__APOLLO_STATE__) {//eslint-disable-line
  cache.restore(window.__APOLLO_STATE__);//eslint-disable-line
}
const DataProviderClient = ({
  children, debug, headers, link, addTypename, clientOverride,
  useBatchLink, batchKey, batchKeys = clientBatchKeys
}) => {
  // Useful for progressive hydration (using the same client in another tree).
  if (clientOverride) {
    return (
      <ApolloProvider client={clientOverride}>
        {children}
      </ApolloProvider>
    );
  }

  const linkOpts = {
    uri: getRelativeAPIPath(),
    // adds cookies back for beta hd_dc
    // credentials: 'omit',
    headers,
  };

  if (useBatchLink) {

    const defaultBatchKey = (operation) => {
      const key = batchKeys[operation.operationName] || '';
      return key;
    };

    linkOpts.fetch = (uri, options) => {
      const operationNames = JSON.parse(options.body).map((operation) => operation.operationName);
      return fetch(`${uri}?opname=${operationNames}`, options);
    };

    linkOpts.batchKey = batchKey || defaultBatchKey;
  }

  const httpLink = useBatchLink
    ? new BatchHttpLink(linkOpts)
    : new HttpLink(linkOpts);

  const apolloLink = link || httpLink;

  if (typeof addTypename !== 'undefined') {
    cache.addTypename = addTypename;
  }

  client = new ApolloClient({
    cache,
    link: apolloLink,
    connectToDevTools: debug,
    typeDefs,
  });

  if (debug && !window.__APOLLO_CLIENT__) {
    window.__APOLLO_CLIENT__ = client;
  }

  return (
    <ApolloProvider client={client}>
      {children}
    </ApolloProvider>
  );
};

DataProviderClient.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  debug: PropTypes.bool,
  headers: PropTypes.shape({}),
  // eslint-disable-next-line react/forbid-prop-types
  link: PropTypes.any,
  addTypename: PropTypes.bool,
  useBatchLink: PropTypes.bool,
  clientOverride: PropTypes.shape({}),
  batchKey: PropTypes.func,
  batchKeys: PropTypes.shape({}),
};

DataProviderClient.defaultProps = {
  debug: false,
  headers: {},
  link: null,
  addTypename: true,
  useBatchLink: false,
  clientOverride: null,
  batchKey: null,
  batchKeys: clientBatchKeys
};

DataProviderClient.persistCache = () => {
  return Promise.resolve({});
};

DataProviderClient.getClient = () => {
  return client;
};

export default DataProviderClient;
